import type { CasesCopy } from '../content'

export const th: CasesCopy = {
  note: 'ชื่อลูกค้าและข้อมูลจริงถูกปกปิดตามข้อตกลงรักษาความลับ (NDA) หน้าจอทั้งหมดวาดขึ้นใหม่สำหรับเว็บไซต์นี้ และตัวเลขในภาพเป็นเพียงตัวอย่าง',
  labels: { before: 'ก่อน', after: 'หลัง', results: 'สิ่งที่ลูกค้าได้รับ', modules: 'โมดูล' },
  flagship: {
    id: 'platform',
    sector: 'การจัดจำหน่ายชิ้นส่วนอิเล็กทรอนิกส์ · การค้าระหว่างประเทศ',
    title: 'แพลตฟอร์มดิจิทัลสำหรับผู้จัดจำหน่าย: ตั้งแต่คำขอของลูกค้าจนถึงพิธีการศุลกากร — และการขายผ่าน AI เอเจนต์',
    lead: 'ระบบเดียวสำหรับผู้จัดจำหน่ายชิ้นส่วนอิเล็กทรอนิกส์ระดับสากล: ERP และ CRM สำหรับทุกแผนก พอร์ทัล B2B สำหรับลูกค้า แคตตาล็อกที่อัปเดตตลอดเวลา การค้นหาด้วย AI และการสั่งซื้อจากผู้ช่วย AI ของผู้ซื้อโดยตรง ทุกโมดูลเราออกแบบ สร้าง และพัฒนาต่อเองทั้งหมด',
    before: 'จัดซื้อทางโทรศัพท์และสเปรดชีต ส่งเอกสารทางอีเมล คำนวณระยะเวลาส่งมอบด้วยมือ และเกิดข้อผิดพลาดได้ทุกขั้นตอน',
    after: 'ระบบอัตโนมัติครบวงจรตั้งแต่หาซัพพลายเออร์จนถึงรับสินค้าเข้าคลัง ทุกคำสั่งซื้อติดตามได้ทุกขั้นตอน และผู้ซื้อค้นหาและสั่งชิ้นส่วนได้เอง — บนเว็บไซต์ หรือผ่าน AI เอเจนต์ของตัวเอง',
    metrics: [
      { value: '~8 ล้าน', label: 'รายการในแคตตาล็อก' },
      { value: '15+', label: 'ผู้จัดจำหน่ายทั่วโลกในการค้นหาครั้งเดียว' },
      { value: '×17', label: 'เปิดหน้าแคตตาล็อกเร็วขึ้น' },
      { value: '~1 นาที', label: 'จากคำขอในผู้ช่วย AI จนได้ใบแจ้งหนี้' },
    ],
    modules: [
      {
        id: 'erp',
        tab: 'ERP และ CRM',
        title: 'หัวใจของการดำเนินงาน',
        lead: 'ห่วงโซ่การขายทั้งหมดอยู่ในระบบเดียว ตั้งแต่คำขอของลูกค้าจนถึงเอกสารปิดงาน มีพนักงานกว่า 100 คนใช้งานทุกวัน ทั้งผู้บริหาร ฝ่ายขาย ฝ่ายจัดซื้อ โลจิสติกส์ วิศวกร คลังสินค้า และพนักงานส่งของ',
        points: [
          'จัดซื้อ: ราคา ใบอนุญาต การรับรอง และระยะเวลาส่งมอบ',
          'การชำระเงิน: ควบคุมการจ่ายตามกฎภาษีของประเทศซัพพลายเออร์ รองรับผ่อนชำระและจ่ายล่วงหน้า สัญญาและใบแจ้งหนี้อยู่ที่เดียว',
          'โลจิสติกส์: จัดส่ง รวมสินค้าที่คลังพักสินค้า ติดตามผู้ขนส่ง และรับสินค้าเข้าคลัง',
          'ศุลกากร: ขั้นตอนอัตโนมัติสำหรับตัวแทนออกของ ยื่นเอกสาร ใบอนุญาต และใบรับรอง',
          'เชื่อมต่อกับระบบบัญชี WMS CRM และผู้ขนส่ง — ไม่ต้องกรอกข้อมูลซ้ำ',
        ],
      },
      {
        id: 'portal',
        tab: 'พอร์ทัล B2B',
        title: 'บริการตนเองสำหรับลูกค้า',
        lead: 'ลูกค้าค้นหาชิ้นส่วน เปรียบเทียบข้อเสนอ และสั่งซื้อได้เอง — ไม่ต้องติดต่อผู้จัดการไปมา',
        points: [
          'ข้อเสนอจากผู้จัดจำหน่ายทั่วโลกกว่า 15 รายในตารางเดียว',
          'ค้นหาตามพาร์ตนัมเบอร์และเทียบราคาแบบเรียลไทม์ — รวมราคาขั้นบันได จำนวนขั้นต่ำ และจำนวนต่อแพ็ก',
          'ไฮไลต์ข้อเสนอที่ดีที่สุดให้อัตโนมัติ สั่งซื้อได้ในไม่กี่คลิก',
          'ติดตามการจัดส่งได้ทุกขั้นตอน',
        ],
      },
      {
        id: 'catalog',
        tab: 'แคตตาล็อก',
        title: 'แคตตาล็อกที่มีชีวิตกว่า ~8 ล้านรายการ',
        lead: 'รากฐานของทุกบริการ: ข้อมูลที่ถูกจัดมาตรฐานแล้ว ทั้งคน เสิร์ชเอนจิน และ AI เอเจนต์เข้าใจได้',
        points: [
          '~8 ล้านรายการใน ~940 หมวด จากผู้ผลิต ~4,700 ราย และพารามิเตอร์ทางเทคนิคที่แยกแล้ว ~80 ล้านค่า',
          'ค้นหาอัจฉริยะ: พิมพ์ «คาปาซิเตอร์เซรามิก» แล้วหมวดที่ถูกต้องจะเปิดขึ้นพร้อมตัวกรองที่ตั้งไว้แล้ว',
          'หน้าสินค้า: คำอธิบายที่เข้าใจง่าย ดาต้าชีต ราคาและสต็อกในตลาด แนวโน้มราคา 3 เดือน ความต้องการ และชิ้นส่วนทดแทนตามพารามิเตอร์',
          'อัปเดตทุกวันจากการค้นหาของลูกค้า ระบบของวิศวกร และข้อมูลซัพพลายเออร์',
          'พร้อมสำหรับการจัดทำดัชนี: URL อ่านง่าย คำอธิบายสองภาษาเกือบทุกรายการ หน้าหมวดพร้อมตัวกรองเปิดใน ~1 วินาที แทน ~17 วินาที',
        ],
      },
      {
        id: 'search',
        tab: 'ค้นหาด้วย AI',
        title: 'สเปกแบบไหนก็ได้ — กลายเป็นคำสั่งซื้อพร้อมใช้',
        lead: 'ลูกค้าไม่ต้องเตรียมข้อมูล ระบบเข้าใจเองว่าได้รับอะไรมา และหาข้อเสนอที่ดีที่สุดให้',
        points: [
          'พาร์ตนัมเบอร์ คำอธิบายตามพารามิเตอร์ และข้อความอิสระปนกันได้ — สูงสุด 100 บรรทัดต่อการค้นหา',
          'ไฟล์ทุกรูปแบบ — สเปรดชีต PDF เอกสาร ภาพถ่าย และไฟล์สแกน ระบบตัดหัวตารางและข้อความที่ไม่เกี่ยวข้องออกเอง: เอกสาร 70 บรรทัดเหลือ 13 รายการ',
          '«ตัวต้านทาน 10 kΩ 0402 1%» กลายเป็นพาร์ตนัมเบอร์ที่ตรงกันพร้อมข้อเสนอจากซัพพลายเออร์',
          'หาชิ้นส่วนทดแทนตามพารามิเตอร์หลัก ไม่ใช่ตามตัวอักษรที่คล้ายกันในชื่อ',
          'ราคาที่ดีที่สุดโดยคำนึงถึงจำนวนขั้นต่ำ จำนวนต่อแพ็ก และสต็อก — ใส่ตะกร้าได้ทันที',
        ],
      },
      {
        id: 'agent',
        tab: 'AI เอเจนต์',
        title: 'ช่องทางขายใหม่: ซื้อผ่านผู้ช่วย AI ของลูกค้า',
        lead: 'เราเชื่อมร้านค้าเข้ากับ AI เอเจนต์ผ่านมาตรฐาน MCP AI เอเจนต์ใดก็ตามที่รองรับ MCP สามารถทำงานกับร้านค้าได้โดยตรง ลูกค้าแค่ให้โจทย์และยืนยัน ที่เหลือเอเจนต์ทำให้ทั้งหมด',
        points: [
          'ข้อมูลเข้า: รายการพาร์ตนัมเบอร์ คำอธิบายตามพารามิเตอร์ หรือ BOM สูงสุด 50 บรรทัด',
          'ค้นหา → คัดเลือก → สั่งซื้อ → ออกใบแจ้งหนี้ ภายในประมาณหนึ่งนาที',
          'ตัวปรับค่าที่เหมาะสมจะจัดคำสั่งซื้อที่คุ้มค่าที่สุด โดยคำนึงถึงจำนวนขั้นต่ำ จำนวนต่อแพ็ก สต็อก และระยะเวลาส่งมอบ',
          'สั่งซื้อในนามบริษัทของลูกค้าเท่านั้น และต้องได้รับการยืนยันก่อน ใบแจ้งหนี้ส่งมาในแชตทันที',
        ],
      },
    ],
  },
  energy: [
    {
      id: 'grid',
      sector: 'พลังงาน · โครงข่ายไฟฟ้า',
      title: 'แบบจำลองดิจิทัลของโครงข่ายไฟฟ้าตามมาตรฐาน CIM',
      lead: 'ระบบซอฟต์แวร์สำหรับผู้ให้บริการโครงข่ายไฟฟ้า ภายใต้โครงการระดับชาติด้านการแปลงโครงสร้างพื้นฐานเป็นดิจิทัล ระบบสร้างแบบจำลองดิจิทัลโดยละเอียดขององค์กรทั้งหมด — โครงข่าย อุปกรณ์ ค่าการวัด และงานภาคสนาม — และอัปเดตอยู่เสมอ: การเปลี่ยนแปลงจะปรากฏในระบบทันทีที่งานเสร็จ',
      standard: 'CIM · IEC 61970-301 · IEC 61968-11',
      before: 'วิศวกรเดินตรวจสายด้วยเท้า ข้อมูลอยู่ในสมุดจดและสเปรดชีตที่กระจัดกระจาย แผนผังเป็นกระดาษ ก่อนการพิจารณาค่าไฟทุกครั้งต้องรวบรวมตัวเลขด้วยมือ',
      after: 'แบบจำลองดิจิทัลเดียวของโครงข่าย อุปกรณ์ และงาน ที่ไม่สามารถบิดเบือน ลบ หรือซ่อนได้ ข้อมูลสำหรับค่าไฟ งานซ่อม และการเชื่อมต่อผู้ใช้ไฟรายใหม่ส่งออกได้ในไม่กี่คลิก',
      metrics: [
        { value: 'หลายเท่า', label: 'ลดภาระการวางแผนงานภาคสนาม' },
        { value: '1 แบบจำลอง', label: 'แทนแผนผังกระดาษและสเปรดชีตที่กระจัดกระจาย' },
        { value: 'CIM', label: 'มาตรฐานสากลสำหรับแบบจำลองโครงข่ายและการแลกเปลี่ยนข้อมูล' },
        { value: '∞', label: 'จำนวนผู้ใช้ — ค่าลิขสิทธิ์ไม่ขึ้นกับจำนวนนี้' },
      ],
      modules: [
        {
          id: 'grid-model',
          tab: 'แบบจำลองโครงข่าย',
          title: 'แผนผังการเชื่อมต่อทางไฟฟ้าแบบรวมศูนย์',
          lead: 'แบบจำลองโทโพโลยีของโครงข่ายเป็นรากฐานของศูนย์ควบคุม และเชื่อมต่อกับระบบควบคุมที่มีอยู่ได้',
          points: [
            'แผนที่โครงข่ายแบบอินเทอร์แอกทีฟที่อ้างอิงพิกัดจริง — บน GIS และแผนที่ออนไลน์',
            'แบ่งตามระดับแรงดัน สายเคเบิลใต้ดิน และสายอากาศ',
            'เครื่องมือแก้ไขสายส่งที่นำเข้า KML และ GPX ได้ และเครื่องมือแก้ไขสถานีไฟฟ้าพร้อมแผนภาพเส้นเดียว',
            'แบบจำลองทรัพย์สินและข้อมูลอ้างอิงที่ผูกกับแผนผัง — พื้นฐานของแบบจำลองการคำนวณ',
            'การแลกเปลี่ยนข้อมูลผ่านโปรโตคอลมาตรฐาน CIM ช่วยลดต้นทุนการเชื่อมต่อกับระบบอื่น',
          ],
        },
        {
          id: 'grid-asset',
          tab: 'ประวัติทรัพย์สิน',
          title: 'ประวัติครบถ้วนของทรัพย์สินทุกชิ้นในโครงข่าย',
          lead: 'เสาไฟ สายส่ง สถานีไฟฟ้า และอุปกรณ์ทุกชิ้นมีข้อมูลทางเทคนิค ภาพถ่าย ค่าการวัด และประวัติการทำงานเก็บไว้ในระบบ',
          points: [
            'เห็นอุปกรณ์บนแผนที่ได้ชัดเจน ทีมช่างหาจุดหมายในพื้นที่ได้ง่ายจากชื่อในระบบควบคุม',
            'ทะเบียนเสาไฟพร้อมภาพถ่าย: วัสดุ หน้าที่ โครงสร้าง และสายที่พาดอยู่',
            'ประวัติงาน ค่าการวัด และทะเบียนทรัพย์สินเก็บในระบบและไม่มีวันสูญหาย',
            'ข้อมูลมาจากทุกหน่วยงานที่เกี่ยวข้อง และผู้รับผิดชอบเข้าถึงได้ทันที',
          ],
        },
        {
          id: 'grid-monitor',
          tab: 'การเฝ้าติดตาม',
          title: 'สภาพอุปกรณ์และลำดับความสำคัญของงานซ่อม',
          lead: 'แบบจำลองค่าการวัดเชื่อมกับแบบจำลองโครงข่ายและแบบจำลองทรัพย์สิน ระบบจึงรู้สภาพทางเทคนิคและแนะนำว่าควรซ่อมอะไรก่อน',
          points: [
            'เฝ้าติดตามสภาพอุปกรณ์โดยอ้างอิงกับแบบจำลองโครงข่าย',
            'วิเคราะห์และประเมินสภาพ — พื้นฐานของแผนปรับปรุงและเปลี่ยนอุปกรณ์',
            'อัลกอริทึมจัดลำดับข้อบกพร่องตามความรุนแรงและความสำคัญของอุปกรณ์',
            'แผนงานซ่อมที่เหมาะสมที่สุดพร้อมทรัพยากรที่ต้องใช้',
            'จัดทำแผนการลงทุนได้เร็วขึ้นมาก เพราะอุปกรณ์ถูกจัดลำดับความสำคัญไว้แล้ว',
          ],
        },
        {
          id: 'grid-works',
          tab: 'งานซ่อมและการเชื่อมต่อ',
          title: 'บริหารงานภาคสนาม',
          lead: 'ระบบติดตามงานซ่อมและการเชื่อมต่อผู้ใช้ไฟรายใหม่ และเจ้าหน้าที่ควบคุมเห็นตำแหน่งของทุกทีมตลอดเวลา',
          points: [
            'วางแผนงานซ่อม: ซ่อมบำรุงตามแผน ตามสภาพ หรือแบบผสม',
            'มาตรฐานเวลาและจำนวนคนสำหรับงานแต่ละประเภทมีอยู่ในระบบแล้ว',
            'ประเมินทรัพยากรตามคู่มืออ้างอิงที่ใช้อยู่',
            'รวบรวมข้อมูลเพื่อเชื่อมต่อผู้ใช้ไฟรายใหม่ได้เร็วขึ้น ผู้ใช้ไฟจึงได้รับการเชื่อมต่อเร็วขึ้น',
          ],
        },
      ],
      results: [
        { title: 'ข้อมูลเป็นปัจจุบัน', text: 'การเปลี่ยนแปลงในโครงข่ายปรากฏทันทีหลังงานเสร็จ — ข้อมูลองค์กรเป็นปัจจุบันเสมอ' },
        { title: 'ข้อมูลได้รับการปกป้อง', text: 'เมื่อใช้งานเต็มรูปแบบ ข้อมูลโครงข่ายไม่สามารถบิดเบือน ลบ หรือซ่อนได้ และกำหนดสิทธิ์เข้าถึงตามบทบาท' },
        { title: 'ราคาคงที่', text: 'ค่าลิขสิทธิ์ไม่ผูกกับจำนวนผู้ใช้' },
        { title: 'ใช้ได้ทุกอุปกรณ์', text: 'ทำงานผ่านเบราว์เซอร์ — ในสำนักงาน ศูนย์ควบคุม และภาคสนาม' },
        { title: 'ลดการพึ่งพาคนเฉพาะ', text: 'ความรู้เกี่ยวกับโครงข่ายอยู่ในระบบ ไม่ได้อยู่กับคนไม่กี่คน และเรียนรู้การใช้งานได้ด้วยการอบรมสั้น ๆ' },
        { title: 'ยืดหยุ่น', text: 'ปรับให้เข้ากับอุปกรณ์หลากหลายและขยายด้วยโมดูลใหม่ได้' },
      ],
    },
    {
      id: 'panel',
      sector: 'พลังงาน · ระบบกำหนดค่าทางวิศวกรรม',
      title: 'สถานีไฟฟ้าย่อยพร้อมเอกสารครบชุด — ใน 10 นาที',
      lead: 'ระบบบนเว็บสำหรับองค์กรขนาดใหญ่ในภาคพลังงาน: คำนวณสถานีไฟฟ้าย่อยสำเร็จรูปทุกประเภทหลัก และตู้ควบคุมไฟฟ้าแรงดันต่ำได้ครบถ้วน พร้อมเอกสารทางเทคนิคและการค้า วิศวกรหรือฝ่ายขายเพียงระบุความต้องการ ระบบจะหาทางออกที่ดีที่สุดและเตรียมเอกสารให้ทุกแผนก',
      before: 'การจัดวาง รูปลักษณ์ การเลือกอุปกรณ์ สเปก และงบประมาณ ทำด้วยมือทั้งหมด — ใช้เวลาหลายชั่วโมงหรือหลายวันต่อโปรเจกต์ และทุกครั้งที่ความต้องการเปลี่ยนต้องคำนวณใหม่ตั้งแต่ต้น',
      after: 'ใส่ความต้องการเข้าไป — ได้ทางออกที่ดีที่สุดและเอกสารครบชุด ภายในไม่เกิน 10 นาที เมื่อความต้องการเปลี่ยน ระบบคำนวณใหม่เฉพาะส่วนที่ได้รับผลกระทบ',
      metrics: [
        { value: '≤10 นาที', label: 'คำนวณสถานีไฟฟ้าย่อยพร้อมเอกสารครบ' },
        { value: '10+', label: 'เอกสารต่อโปรเจกต์ — สร้างอัตโนมัติ' },
        { value: '3 ทีม', label: 'ได้รับชุดเอกสารของตัวเอง: ขาย จัดซื้อ ผลิต' },
        { value: '0', label: 'ตัวเลือกที่ไม่เข้ากัน — ระบบไม่ยอมให้ผ่าน' },
      ],
      modules: [
        {
          id: 'panel-spec',
          tab: 'ข้อกำหนด',
          title: 'ข้อกำหนดทางเทคนิคแบบออนไลน์',
          lead: 'ข้อกำหนดสำคัญทั้งหมดกรอกในฟอร์มเดียว และปรับได้ทุกเมื่อ — ทางออกจะอัปเดตทันที',
          points: [
            'ตรรกะการเลือกอุปกรณ์คำนึงถึงข้อกำหนดทางเทคนิค แคตตาล็อกผู้ผลิต คู่มือ และมาตรฐาน',
            'คำแนะนำช่วยให้เลือกง่ายขึ้น และไม่สามารถเลือกตัวเลือกที่ไม่เข้ากันได้เลย',
            'ข้อมูลจากแคตตาล็อกผู้ผลิตอยู่ในระบบแล้ว',
            'เมื่อความต้องการเปลี่ยน แค่ปรับค่าที่เกี่ยวข้อง ส่วนที่เหลือระบบคำนวณเอง',
          ],
        },
        {
          id: 'panel-scheme',
          tab: 'แผนภาพและการจัดวาง',
          title: 'แผนภาพเส้นเดียวและรูปลักษณ์ — อัตโนมัติ',
          lead: 'เครื่องมือแก้ไขแบบอินเทอร์แอกทีฟพร้อมคลังบล็อกฟังก์ชัน และคำนวณพารามิเตอร์การติดตั้งให้อัตโนมัติ',
          points: [
            'แผนภาพเส้นเดียวจากคลังบล็อกฟังก์ชัน',
            'คำนวณพารามิเตอร์การติดตั้งอัตโนมัติ',
            'ดูรูปลักษณ์และขนาดตามสเกล — ลูกค้าเห็นผลงานก่อนผลิตจริง',
            'ใช้วิธีการออกแบบเดียวกัน ไม่ว่าวิศวกรคนไหนจะรับผิดชอบ',
          ],
        },
        {
          id: 'panel-docs',
          tab: 'เอกสาร',
          title: 'ชุดเอกสารเฉพาะของแต่ละแผนก',
          lead: 'เอกสารสร้างอัตโนมัติ แก้ไขได้ออนไลน์ และผ่านการอนุมัติและลงทะเบียนในแผนกที่เกี่ยวข้อง',
          points: [
            'ฝ่ายขาย: แผนภาพเส้นเดียว ภาพรวมภายนอก สัญญาซื้อขายและเอกสารแนบสเปก ใบแจ้งหนี้ และใบเสนอราคา',
            'ฝ่ายจัดซื้อ: สเปกอุปกรณ์ วัสดุ โลจิสติกส์ ค่าแรง และค่าใช้จ่ายทางอ้อม',
            'ฝ่ายประกอบ: ภาพรวมภายนอก แผนภาพเส้นเดียว สเปก และแบบประกอบ',
            'ส่งออกเป็น PDF, XLS และ DXF',
          ],
        },
        {
          id: 'panel-bom',
          tab: 'ประมาณราคาและการตั้งค่า',
          title: 'ประมาณราคาโปร่งใส ปรับให้เข้ากับผู้ผลิต',
          lead: 'ทุกตู้ ทุกโมดูล และทุกชิ้นส่วนมีราคากำกับ ผู้บริหารเห็นชัดว่าต้นทุนโปรเจกต์มาจากอะไร',
          points: [
            'สเปกแยกตามตู้ โมดูล และชิ้นส่วนพร้อมราคา — อัตโนมัติ',
            'การคำนวณต้นทุนโปรเจกต์ที่โปร่งใสสำหรับผู้บริหาร',
            'ตั้งค่าได้หลากหลายสำหรับผู้ผลิตและองค์กรแต่ละแห่ง',
            'เชื่อมต่อกับระบบซอฟต์แวร์และระบบสารสนเทศอื่นได้',
          ],
        },
      ],
      results: [
        { title: 'ใบเสนอราคาในไม่กี่นาที', text: 'ลูกค้าได้รับข้อมูลทางเทคนิคและการค้าครบถ้วนอย่างรวดเร็ว' },
        { title: 'ข้อผิดพลาดน้อยลง', text: 'ไม่สามารถเลือกอุปกรณ์ที่ไม่เข้ากันได้' },
        { title: 'งานซ้ำซากน้อยลง', text: 'พนักงานไม่ต้องจัดวาง เลือกอุปกรณ์ และคำนวณเองอีกต่อไป' },
        { title: 'โปร่งใส', text: 'ผู้บริหารเห็นการคำนวณต้นทุนทั้งหมดของโปรเจกต์' },
        { title: 'เห็นก่อนผลิต', text: 'เห็นรูปลักษณ์และขนาดตามสเกลล่วงหน้า' },
        { title: 'มาตรฐานเดียว', text: 'ทุกโปรเจกต์ใช้วิธีการเดียวกัน ไม่ว่าใครจะรับผิดชอบ' },
      ],
    },
  ],
  ui: {
    erp: { columns: ['คำขอ', 'กำลังคำนวณ', 'ใบเสนอราคาพร้อม', 'ส่งลูกค้าแล้ว'], modules: ['จัดซื้อ', 'ชำระเงิน', 'โลจิสติกส์', 'ศุลกากร'], search: 'ค้นหาตามพาร์ตนัมเบอร์หรือแบรนด์', qty: 'ชิ้น' },
    portal: { search: 'พาร์ตนัมเบอร์', qty: 'จำนวน', find: 'ค้นหา', supplier: 'ซัพพลายเออร์', stock: 'สต็อก', lead: 'ระยะเวลา', price: 'ราคา, $', total: 'รวม, $', best: 'ดีที่สุด', weeks: 'สัปดาห์', suppliers: ['ผู้จัดจำหน่าย · เอเชีย', 'คลังสินค้า · ยุโรป', 'ผู้ขายที่ตรวจสอบแล้ว', 'ตัวแทนจำหน่ายอย่างเป็นทางการ'] },
    catalog: { query: 'คาปาซิเตอร์เซรามิก', section: 'ตัวเก็บประจุเซรามิก', positions: '~430,000 รายการ', filters: 'ตัวกรอง', apply: 'ใช้', relevance: 'ความเกี่ยวข้อง', partNumber: 'พาร์ตนัมเบอร์', maker: 'ผู้ผลิต', median: 'ราคากลาง', inStock: 'มีสต็อกที่ซัพพลายเออร์ 6 ราย', demand: 'ความต้องการ', analogs: 'ชิ้นส่วนทดแทน', datasheet: 'ดาต้าชีต', offers: 'ข้อเสนอสด', trend: '3 เดือน' },
    search: { title: 'ค้นหาด้วย AI', rows: ['MAX3485ESA 700', 'ตัวต้านทาน 10 kΩ 0402 1% 25', 'BAV99 100', 'ตัวเก็บประจุ 100 nF 50 V X7R 0603 3000', 'บรรทัดที่อ่านไม่เข้าใจ'], exact: 'พาร์ตนัมเบอร์ตรงกัน', byParams: 'ตามพารามิเตอร์ · 5 ตัวเลือก', analog: 'ทดแทน', unknown: 'ระบุบรรทัดให้ชัด', counter: '2 พาร์ตนัมเบอร์ · 3 คำอธิบาย', file: 'spec.pdf', fileResult: '70 บรรทัด → 13 รายการ ตัดออก 57', find: 'ค้นหา', toCart: 'ใส่ตะกร้า' },
    agent: {
      title: 'ผู้ช่วย AI ของลูกค้า · MCP',
      user1: 'หา BAV99 ให้หน่อย ต้องการ 1,000 ชิ้น',
      tool1: 'search_partnumber',
      agent1: 'พบข้อเสนอประมาณ 470 รายการจากซัพพลายเออร์ 16 ราย มีสต็อกราว 23 ล้านชิ้น ส่งเร็วที่สุดใน 4 วัน',
      user2: 'เลือกตัวเลือกที่ถูกที่สุดที่ส่งภายใน 14 วัน',
      tool2: 'get_best_offer',
      agent2: '1,000 ชิ้น ราคา $0.004 — รวม $4.00 ส่งใน 7 วัน รับเองฟรี',
      confirm: 'สั่งซื้อเลยไหม?',
      user3: 'ได้เลย สั่งแล้วส่งใบแจ้งหนี้มาด้วย',
      tool3: 'create_order · get_invoice',
      agent3: 'สั่งซื้อในนามบริษัทของคุณแล้ว ใบแจ้งหนี้แนบมาด้วย',
      invoice: 'ใบแจ้งหนี้.pdf',
      typing: 'เอเจนต์กำลังทำงานกับร้านค้า…',
    },
    grid: { editor: 'แก้ไข', scheme: 'แผนผังโครงข่าย', layers: ['สายส่ง', 'สถานีไฟฟ้า', 'เสาไฟ', 'ผู้ใช้ไฟ', 'การเฝ้าติดตาม'], legend: ['110 kV', '10 kV', '0.4 kV'], substation: 'สถานี-12 · 10/0.4 kV', search: 'ที่อยู่หรือจุดติดตั้ง' },
    panel: { units: 'บล็อกฟังก์ชัน', settings: 'พารามิเตอร์', params: [['แรงดัน', '380 V'], ['ความถี่', '50 Hz'], ['กระแสบัสบาร์', '630 A'], ['ระดับการป้องกัน', 'IP42'], ['สำรอง', '10 %']], front: 'มุมมองด้านหน้า', export: 'ส่งออก', feeder: 'วงจรออก' },
    tower: { title: 'เสาต้นที่ 14 · สาย 10 kV', photo: 'ภาพถ่าย · 3', rows: [['วัสดุ', 'คอนกรีตเสริมเหล็ก'], ['หน้าที่', 'เสากลางทาง'], ['โครงสร้าง', 'เสาเดี่ยว'], ['สาย', '10 kV L-2 · 0.4 kV L-5'], ['สภาพ', 'ใช้งานได้ดี']], history: 'ประวัติ', events: [['12/08', 'ตรวจสอบ · วัดค่าดิน'], ['03/06', 'เปลี่ยนลูกถ้วย'], ['19/04', 'ขึ้นทะเบียน · ถ่ายภาพ']], add: 'มอบหมายงาน' },
    monitor: { title: 'จัดลำดับข้อบกพร่อง', cols: ['จุดติดตั้ง', 'ข้อบกพร่อง', 'ความรุนแรง', 'ซ่อม'], rows: [['สถานี-12', 'หน้าสัมผัสร้อนเกิน', 92, 'สัปดาห์ 38'], ['10 kV L-3', 'เสาเอียง', 78, 'สัปดาห์ 40'], ['0.4 kV C-7', 'ฉนวนเสื่อม', 64, 'สัปดาห์ 43'], ['สถานี-5', 'น้ำมันรั่ว', 41, 'ไตรมาส 4']], schedule: 'แผนงานซ่อม', weeks: ['38', '39', '40', '41', '42', '43'], resources: 'ทรัพยากร', crew: '2 ทีม · 46 ชั่วโมงคน' },
    works: { title: 'ใบสั่งงาน', columns: ['วางแผน', 'กำลังทำ', 'เสร็จแล้ว'], items: [['เชื่อมต่อผู้ใช้ไฟ · 150 kW', 'สถานี-9', 0], ['เปลี่ยนเสาต้นที่ 31', '10 kV L-4', 0], ['ซ่อมสถานี-12', 'ตามสภาพ', 1], ['ตรวจสาย 0.4 kV L-5', 'ตามแผน', 1], ['วัดโหลดสถานี-3', 'ตามแผน', 2], ['เปลี่ยนลูกถ้วย', '10 kV L-2', 2]], crew: 'ทีม 3', crewStatus: 'อยู่หน้างาน · สถานี-12', connection: 'เชื่อมต่อผู้ใช้ไฟ' },
    spec: { title: 'ข้อกำหนด · โปรเจกต์ 2417', fields: [['ประเภทสถานี', 'สถานีสำเร็จรูป'], ['หม้อแปลง', '2 × 1000 kVA'], ['แรงสูง / แรงต่ำ', '10 / 0.4 kV'], ['สวิตช์เกียร์แรงสูง', 'บัสบาร์เดี่ยว'], ['วงจรออกแรงต่ำ', '12'], ['กระแสบัสบาร์แรงต่ำ', '1600 A'], ['รูปแบบ', 'มีฉนวนกันความร้อน']], warning: 'เบรกเกอร์ขาเข้า 630 A ใช้กับบัสบาร์ 1600 A ไม่ได้', fix: 'เปลี่ยนเป็น 1600 A', recalc: 'คำนวณใหม่แล้ว: แผนภาพ สเปก ประมาณราคา', build: 'สร้างเอกสาร' },
    docs: { departments: ['ฝ่ายขาย', 'ฝ่ายจัดซื้อ', 'ฝ่ายประกอบ'], items: [['แผนภาพเส้นเดียว', 'ภาพรวมภายนอก', 'สัญญาซื้อขาย', 'สเปกแนบสัญญา', 'ใบแจ้งหนี้', 'ใบเสนอราคา'], ['สเปกอุปกรณ์', 'สเปกวัสดุ', 'สเปกโลจิสติกส์', 'ค่าแรงและค่าใช้จ่าย'], ['ภาพรวมภายนอก', 'แผนภาพเส้นเดียว', 'สเปกอุปกรณ์', 'สเปกวัสดุ', 'แบบประกอบ']], approved: 'อนุมัติแล้ว', editing: 'รออนุมัติ' },
    bom: { title: 'สเปกและประมาณราคา', cols: ['ตู้', 'โมดูล', 'ชิ้นส่วน', 'ราคา'], rows: [['ตู้ 1 · ขาเข้า', 'QF-2 · ACB', 'เบรกเกอร์ 1600 A', '20 150'], ['ตู้ 2 · บัสคัปเปลอร์', 'QF-6.1 · ACB', 'เบรกเกอร์ 630 A', '11 010'], ['ตู้ 3 · วงจรออก', 'QF-6.2 · MCCB × 6', 'เบรกเกอร์ 250 A', '4 860'], ['ตู้ 4 · มิเตอร์', 'PM-1 · มิเตอร์', 'มิเตอร์ CT', '2 150'], ['ตู้ 5 · สลับแหล่งจ่าย', 'ATS-1', 'ตัวควบคุม ATS', '1 680']], total: 'รวมทั้งโปรเจกต์', totalValue: '39 850', maker: 'ผู้ผลิต: ตั้งค่าได้' },
  },
}
